<template>
    <ValidationObserver ref="observer"
                        tag="form"
                        class="row d-flex mx-2"
                        @submit.prevent="submit">
        <div class="col-sm-6 py-4">
            <ValidationProvider tag="div"
                                class="mb-4"
                                vid="name"
                                mode="lazy"
                                :customMessages="{required: 'Norādi uzņēmuma nosaukumu.'}"
                                rules="required"
                                v-slot="{errors}">
                <label for="name" class="d-block text-secondary text-left mb-0">Nosaukums</label>
                <input type="text" id="name" class="w-100 py-1 ds-input" v-model="company.name">
                <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider tag="div"
                                vid="email"
                                mode="lazy"
                                rules="required|email"
                                :customMessages="{required: 'Norādi uzņēmuma e-pastu.', email: 'Norādi pareizu e-pastu.'}"
                                v-slot="{errors}">
                <label for="email" class="d-block text-secondary text-left mb-0">E-pasts</label>
                <input type="text" id="email" class="w-100 py-1 ds-input" v-model="company.email">
                <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
            </ValidationProvider>

            <div v-if="company._id" class="mt-4">
                <ValidationProvider tag="div"
                                    vid="ovpName"
                                    mode="lazy"
                                    v-slot="{errors}">
                    <label for="email" class="d-block text-secondary text-left mb-0">Uzņēmuma nosaukums</label>
                    <input type="text" id="ovpName" class="w-100 py-1 ds-input" v-model="company.ovpName" placeholder="SIA Uzņēmums">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider tag="div"
                                    vid="ovpRegNumber"
                                    mode="lazy"
                                    v-slot="{errors}">
                    <label for="email" class="d-block text-secondary text-left mb-0">Reģistrācijas numurs</label>
                    <input type="text" id="ovpRegNumber" class="w-100 py-1 ds-input" v-model="company.ovpRegNumber" placeholder="112233445566">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider tag="div"
                                    vid="ovpAddress"
                                    mode="lazy"
                                    v-slot="{errors}">
                    <label for="email" class="d-block text-secondary text-left mb-0">Juridiskā adrese</label>
                    <input type="text" id="ovpAddress" class="w-100 py-1 ds-input" v-model="company.ovpAddress" placeholder="Rīgas iela 23, Rīga, LV-1234">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <div class="col-sm-6 d-flex justify-content-center align-items-center">
            <ImageUpload @uploaded="setLogoUrl" :image="company.logoPath"/>
        </div>

        <CustomButton class="w-25 mb-4 ds-btn--success"
                      :btn-text="company._id ? 'Saglabāt izmaiņas' : 'Pievienot'"
                      :is-loading="isActiveRequest"/>
    </ValidationObserver>
</template>
<script>
    import {mapGetters, mapActions, mapMutations} from 'vuex';
    import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
    import {email, required} from 'vee-validate/dist/rules';
    import _ from 'lodash';

    import CustomButton from '@/components/global/CustomButton';
    import ImageUpload from '@/components/global/ImageUpload';
    import {Company} from '../../vuex/modules/company/models/company.models';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types';

    export default {
        name: 'companies-base-form',
        components: {
            CustomButton,
            ImageUpload,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            currentCompany: {
                type: Company,
                required: false,
                default: () => new Company,
            }
        },
        data() {
            return {
                company: Company.fromArray({...this.currentCompany}),
            }
        },
        created() {
            extend('required', required);
            extend('email', email);
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapActions('company', {
                /** @type {function|*} */
                createCompany: companyStoreTypes.ACTION_CREATE_COMPANY,
                /** @type {function|*} */
                updateCompany: companyStoreTypes.ACTION_UPDATE_COMPANY,
            }),
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if (!isValid) {
                    return;
                }

                const formattedCompany = _.cloneDeep(this.company).cleanUp();

                try {
                    if (this.company._id) {
                        await this.updateCompany(formattedCompany);
                        return this.setAlertData({type: 'primary', message: 'Uzņēmuma izmaiņas saglabātas!'});
                    }

                    await this.createCompany(formattedCompany);
                    this.setAlertData({type: 'primary', message: 'Uzņēmums pievienots!'});
                    this.reset();
                } catch (error) {
                    this.$refs.observer.setErrors({[error.field]: [error.message]});
                }
            },
            reset() {
                this.company = new Company;
                this.$refs.observer.reset();
                this.$emit('finished');
            },
            /**
             * @param {string} logoUrl
             */
            setLogoUrl(logoUrl) {
                this.company.logo = logoUrl;
            },
        },
        computed: mapGetters('company', {
            /** @type {boolean|*} */
            isActiveRequest: companyStoreTypes.GET_IS_ACTIVE_REQUEST,
        })
    }
</script>